import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

const PageTitleContext = createContext({ override: null, setOverride: () => {} });

export function PageTitleProvider({ children }) {
  // Stored with the pathname it was set on, so a title never leaks onto the next page.
  const [override, setOverride] = useState(null);
  const value = useMemo(() => ({ override, setOverride }), [override]);
  return <PageTitleContext.Provider value={value}>{children}</PageTitleContext.Provider>;
}

/** Title set by the current page via usePageTitle, or null. */
export function usePageTitleOverride() {
  const { override } = useContext(PageTitleContext);
  const { pathname } = useLocation();
  return override?.pathname === pathname ? override.title : null;
}

/**
 * Replaces the route's static header title, e.g. with a record name on a detail page.
 * Pass a falsy value while data is loading to keep the route title.
 */
export function usePageTitle(title) {
  const { setOverride } = useContext(PageTitleContext);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!title) return undefined;
    setOverride({ pathname, title });
    return () => setOverride(null);
  }, [title, pathname, setOverride]);
}
